import type { RouteObject } from 'react-router-dom';
import AddListing from '../pages/AddListing';
import Drafts from '../pages/Drafts';
import EditListing from '../pages/EditListing';
import ListingDetail from '../pages/ListingDetail';
import MyListings from '../pages/MyListings';
import NewFromPhotos from '../pages/NewFromPhotos';

export const listingsRoutes: RouteObject[] = [
  { path: '/listings/create', element: <AddListing /> },
  { path: '/collections/:collectionId/listings/create', element: <AddListing /> },
  { path: '/listings/new-from-photos', element: <NewFromPhotos /> },
  { path: '/listings/:id', element: <ListingDetail /> },
  { path: '/listings/:id/edit', element: <EditListing /> },
  { path: '/my-listings', element: <MyListings /> },
  { path: '/my-listings/drafts', element: <Drafts /> },
];
